// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import utils from './utils/index'
import ElementUI from 'element-ui'
import iView from 'iview'
import ba from 'vue-ba'
import preview from 'vue-photo-preview'
import WebSocket from '../src/utils/WebSocket';
import KeyMap from '../src/utils/KeyMap';
import * as custom from '../src/utils/custom';
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-photo-preview/dist/skin.css'
import './style/_normalize.scss'
import './style/_base.scss'
import './style/_reset.scss'
import './style/_variable.scss'
import 'iview/dist/styles/iview.css'


Vue.config.productionTip = false;
Vue.use(preview);
Vue.use(utils);
Vue.use(iView);
Vue.use(ElementUI);
Vue.use(ba, "30ab4eabc9c4affcb5390413df13d54d");
Vue.use(ba, { siteId: "30ab4eabc9c4affcb5390413df13d54d" });
Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
});

Vue.prototype.gbSocket = WebSocket;
Vue.prototype.KeyMap = KeyMap;
// Vue.use(iView);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js